/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Success_BodyInputs */



/**
* | output |
* | --- |
* | "We've filed it on GitHub — you can follow the discussion there." |
*
* @param {Feedback_Success_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_success_body = /** @type {((inputs?: Feedback_Success_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Success_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous l'avons enregistré sur GitHub — vous pouvez y suivre la discussion.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lo hemos registrado en GitHub — puede seguir allí la discusión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registramos no GitHub — você pode acompanhar a discussão por lá.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lo abbiamo registrato su GitHub — puoi seguire la discussione lì.")
	return /** @type {LocalizedString} */ ("We've filed it on GitHub — you can follow the discussion there.")
});